import 'helpers/types/option';
const discountCopy = (discountPercentage) => discountPercentage > 0
    ? {
        roundel: ['Save up to', `${discountPercentage}%`, 'a year'],
        heading: `Save up to ${discountPercentage}% a year with a subscription`,
    }
    : {
        roundel: [],
        heading: 'Save money with a subscription',
    };
export const getDiscountCopy = (discountPercentage) => discountCopy(discountPercentage);
